/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { GetSubscriptionCenterLinkResponse } from '../types/GetSubscriptionCenterLink'

/**
 * GET /notifications/subscription-center-link
 * @see backend/nexus/app/Http/Controllers/GetSubscriptionCenterLinkController.php GetSubscriptionCenterLinkController::__invoke
 */
export async function getSubscriptionCenterLink(
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<GetSubscriptionCenterLinkResponse>> {
	return axiosInstance.get('/notifications/subscription-center-link', config)
}
